import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environments/environment';
import { User } from '../users/user.model'
import { Session } from './session.model'
import { ErrorDialogComponent } from '../shared/error-dialog.component';

@Injectable()
export class AuthService {

  apiHost = environment.apiHost;
  get signInUrl(): string {
    let host = window.location.protocol + "//" + window.location.host
    let url = environment.signInUrl + "?relay=" + host + "/auth/callback"
    return url;
  }
  get signedIn(): boolean {
    return this.currentUser != null
  }
  get currentUser(): User {
    let storedUser = localStorage.getItem('currentUser');
    if (storedUser != null) {
      return new User(JSON.parse(storedUser));
    }
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog) { }

  storeUser(user) {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userProfile');
    if (user != null) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  }

  signIn() {
    this.dialog.closeAll();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userProfile');
    let currentPath = window.location.pathname+window.location.search;
    if (!/^\/auth/.test(currentPath)) {
      localStorage.setItem('authBack', currentPath);
    }
    this.router.navigate(["/auth"])
  }

  signOut(all: boolean = false): Observable<any> {
    let path = all ? "/authorize/sessions" : "/authorize";
    return this.http.delete(this.apiHost+path).map(
      (data) => {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userProfile');
        return data;
      }
    )
  }

  getUser(): Observable<any> {
    return this.http.get(this.apiHost+"/authorize/user").map(
      (data: any) => {
        return new User({
          email: data.email,
          firstName: data.first_name,
          id: data.id,
          lastName: data.last_name
        })
      }
    ).catch((error) => {
      console.log("Get user error:", error);
      if (error.status === 401) {
        this.signIn()
      }
      return Observable.throw(new Error(error.status));
    })
  }

   getSessions(): Observable<any> {
    return this.http.get(this.apiHost+"/authorize/sessions").map(
      (data: any) => {
        return data.map((x) => Session.fromRecord(x))
      }
    ).catch((error) => {
      console.log("Get sessions error:", error);
      if (error.status === 401) {
        this.signIn()
      }
      return Observable.throw(new Error(error.status));
    })
  }

  accessDenied(message: String) {
    this.dialog.closeAll();
    this.router.navigate(["/"]);
    this.showErrorDialog(message);
  }

  showErrorDialog(message) {
    let dialogRef = this.dialog.open(ErrorDialogComponent, {
      height: '240px',
      width: '320px',
      data: {message: message}
    });
    setTimeout(() => dialogRef.close(), 6000);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts